import { ServerAlertAction } from '../../common'
import { ServerAlertActionV2 } from '../../common/types/ServerAlertActionV2'
import { VARIANT } from '../../common/types/ServerAlertDataV2'


let showMsg = (msg: string,vari:any) => {

    let showAlert = (message: string, variant: 'error' | 'success' = 'error'): Partial<ServerAlertAction> => ({
        type: 'SHOW_ALERT', data: { message: message, variant: variant, openSnackbar: true }
    })
    let showAlertLogin = (message: string, variant: VARIANT = VARIANT.LOGIN_ERROR): Partial<ServerAlertActionV2> => ({
        type: 'SHOW_ALERT', data: { message: message, variant: variant, openSnackbarV2: true }
    })
    return (dispatch: any) => {
        dispatch(showAlert(msg, vari));
    }
}

export {
    showMsg
}